<script lang="ts">
	import { cn } from '@ui-lib/utils/utils.js';
	import { ScrollArea as ScrollAreaPrimitive, type WithoutChild } from 'bits-ui';
	import { Scrollbar } from './index.js';
	import type { GestureEvent } from '@ui-lib/types/gesture';

	let {
		el = $bindable(),
		class: className,
		orientation = 'vertical',
		scrollbarXClasses = '',
		scrollbarYClasses = 'z-20 bg-gray-200 dark:bg-gray-800 [&>div]:bg-gray-400 dark:[&>div]:bg-gray-500',
		scrollbarTopOffset = 0,
		children,
		onscroll,
		...restProps
	}: WithoutChild<ScrollAreaPrimitive.RootProps> & {
		el?: HTMLDivElement | null;
		orientation?: 'vertical' | 'horizontal' | 'both' | undefined;
		scrollbarXClasses?: string | undefined;
		scrollbarYClasses?: string | undefined;
		scrollbarTopOffset?: number;
		onscroll?: (event: Event) => void;
		ongesturestart?: (event: GestureEvent) => void;
		ongesturechange?: (event: GestureEvent) => void;
		ongestureend?: (event: GestureEvent) => void;
	} = $props();

	let viewportRef: HTMLDivElement | null = $state(null);

	let isDragging = $state(false);

	$effect(() => {
		el = viewportRef;
	});
</script>

<ScrollAreaPrimitive.Root
	ondragstart={() => {
		isDragging = true;
	}}
	ondragend={() => {
		isDragging = false;
	}}
	{...restProps}
	class={cn('relative', orientation === 'vertical' ? '' : '', className)}
>
	<ScrollAreaPrimitive.Viewport
		bind:ref={viewportRef}
		{onscroll}
		class="h-full w-full rounded-[inherit] {isDragging ? 'pointer-events-none' : ''}"
	>
		{@render children?.()}
	</ScrollAreaPrimitive.Viewport>
	{#if orientation === 'vertical' || orientation === 'both'}
		<Scrollbar orientation="vertical" class={scrollbarYClasses} topOffset={scrollbarTopOffset} />
	{/if}
	{#if orientation === 'horizontal' || orientation === 'both'}
		<Scrollbar orientation="horizontal" class={scrollbarXClasses} />
	{/if}
	<ScrollAreaPrimitive.Corner />
</ScrollAreaPrimitive.Root>
